import MorganList from "./MorganList";

export { MorganList };

export default { MorganList };
